module.exports = __webpack_public_path__ + "static/img/icon_cache.c8bcbb0d.svg";